module.exports = __webpack_public_path__ + "static/media/Overjet (sagittal fissure)12.fddc2cda.png";